import axios from 'axios'

const LrsClient = {
  enableCrossWindowTracking: function() {
    document.domain = 'plurall.net'
  },

  cloneStatement: function(statement) {
    return JSON.parse(JSON.stringify(statement))
  },

  Lrp: class {
    constructor(options) {
      this.userAccessToken = options.userAccessToken
      this.platform = options.platform
    }

    enableH5PListener = contentWindow => {
      const lrpClass = this

      if (lrpClass.shouldDisableTrack()) {
        return
      }

      const h5pClass = contentWindow.H5P
      const h5pParentDocumentUrl = contentWindow.parent.location.href
      h5pClass.externalDispatcher.on('xAPI', function(event) {
        console.log('INITIAL STATEMENT ON externalDispatcher')
        console.log(LrsClient.cloneStatement(event.data.statement))

        const statement = new LrsClient.H5PStatement({
          statement: event.data.statement,
          h5pParentDocumentUrl: h5pParentDocumentUrl,
        })
        try {
          lrpClass.sendStatement(statement.format())
        } catch {}
      })

      this.enableH5PVideoListener(h5pClass, h5pParentDocumentUrl)
    }

    enableH5PVideoListener = (h5pClass, h5pParentDocumentUrl) => {
      if (h5pClass.instances?.length && h5pClass.instances[0]?.video) {
        const lrpClass = this
        const h5pVideoInstance = h5pClass.instances[0]
        const h5pVideoState = new LrsClient.H5PVideoState(h5pClass.Video)
        h5pVideoInstance.video.on('stateChange', function(event) {
          const videoStatement = h5pVideoInstance.getXAPIData().statement
          console.log('INITIAL STATEMENT ON video stateChange')
          console.log(LrsClient.cloneStatement(videoStatement))

          h5pVideoState
            .buildStatementsWith({
              state: event.data,
              statement: videoStatement,
              currentTime: h5pVideoInstance.video.getCurrentTime(),
              title: h5pVideoInstance.getTitle(),
              duration: h5pVideoInstance.video.getDuration(),
            })
            .forEach(statement => {
              const h5pStatement = new LrsClient.H5PStatement({
                statement: statement,
                h5pParentDocumentUrl: h5pParentDocumentUrl,
              })
              lrpClass.sendStatement(h5pStatement.format())
            })
        })
      }
    }

    sendPageReadEvent = pageTitle => {
      const statement = {
        verb: {
          id: 'http://activitystrea.ms/schema/1.0/read',
          display: {
            'pt-BR': 'read',
          },
        },
        object: {
          id: document.location.href,
          definition: {
            type: 'http://activitystrea.ms/schema/1.0/page',
            name: {
              'pt-BR': pageTitle,
            },
          },
        },
      }

      this.sendStatement(statement)
    }

    sendStatement = statement => {
      if (this.shouldDisableTrack()) {
        return
      }

      const lrsStatement = new LrsClient.Statement({
        statement: statement,
        actorId: this.userId,
        platform: this.platform,
      })

      if (!process.env.REACT_APP_LRP_HOST) {
        console.log(
          'LRP SERVER HOST MISSING. PLEASE PROVIDE THIS INFORMATION ON PROJECT ENV VALUES',
        )
        return
      }

      axios({
        method: 'post',
        url: `${process.env.REACT_APP_LRP_HOST}/api/statements`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${this.userAccessToken}`,
        },
        data: JSON.stringify(lrsStatement.toLrs()),
      })
        .then(response => {
          console.log('SAVED STATEMENT ID')
          console.log(response.data)
        })
        .catch(error => {
          console.log('FAIL TO SEND STATEMENT')
          if (error.response) {
            console.log(error.response.data)
          }
        })
    }

    shouldDisableTrack = () => {
      // avoid error  CORS Policy locally
      return (
        process.env.NODE_ENV === 'development' &&
        process.env.REACT_APP_LRP_HOST.indexOf('.local.') === -1
      )
    }
  },

  H5PStatement: class {
    constructor({ statement, h5pParentDocumentUrl }) {
      this.statement = statement
      this.h5pParentDocumentUrl = h5pParentDocumentUrl
    }

    format = () => {
      this.formatObject()
      this.formatContext()

      return this.statement
    }

    formatObject = () => {
      if (!this.statement.object.definition.type) {
        let definitionType = null
        const context = this.statement.context

        if (context && context?.contextActivities?.category) {
          this.statement.context.contextActivities.category.forEach(category => {
            if (category.id.indexOf('Choice') !== -1) {
              definitionType = 'http://adlnet.gov/expapi/activities/cmi.interaction'
              this.statement.object.definition.interactionType = 'choice'
            }

            if (category.id.indexOf('DragQuestion') !== -1) {
              definitionType = 'http://adlnet.gov/expapi/activities/cmi.interaction'
              this.statement.object.definition.interactionType = 'matching'
            }

            if (category.id.indexOf('CoursePresentation') !== -1) {
              definitionType = 'http://id.tincanapi.com/activitytype/slide-deck'
            }
          })
        }

        this.statement.object.definition.type = definitionType
      }
    }

    formatContext = () => {
      if (!this.statement.context.contextActivities.parent) {
        this.statement.context.contextActivities.parent = {
          id: this.h5pParentDocumentUrl,
        }
      }
    }
  },

  H5PVideoState: class {
    constructor(h5pVideoClass) {
      this.h5pVideoClass = h5pVideoClass

      this.lastState = null
      this.lastCurrentTime = null

      //bug native xAPI Video State currentTime
      this.lastCurrentTimeForBuffering = null
    }

    buildStatementsWith = ({ state, statement, currentTime, title, duration }) => {
      const statements = []

      statement.result.extensions = statement.result.extensions || {}
      statement.result.extensions[
        'http://id.tincanapi.com/extension/duration'
      ] = this.secondsAsISO8601Duration(duration)

      statement.object.definition.type = 'http://activitystrea.ms/schema/1.0/video'
      statement.object.definition.name = { 'pt-BR': title }

      statement.result.completion = false

      delete statement.object.definition.interactionType
      delete statement.result.score

      //console.log(`---- current state: ${state} | last state: ${this.lastState}`)
      //console.log(`---- current time: ${currentTime} | last time: ${this.lastCurrentTime}`)

      switch (state) {
        case this.h5pVideoClass.PLAYING:
          this.lastCurrentTimeForBuffering = this.lastCurrentTime
          //console.log(`----- lastCurrentTimeForBuffering: ${this.lastCurrentTimeForBuffering}`)

          if (this.lastState === this.h5pVideoClass.BUFFERING) {
            break //avoid to sent statement when video has buffered
          }
          statement.result.extensions[
            'http://id.tincanapi.com/extension/starting-point'
          ] = this.secondsAsISO8601Duration(currentTime)

          if (this.lastState === null) {
            statement.verb.id = 'http://activitystrea.ms/schema/1.0/start'
            statement.verb.display = { 'pt-BR': 'started' }
          } else {
            statement.verb.id = 'http://activitystrea.ms/schema/1.0/play'
            statement.verb.display = { 'pt-BR': 'played' }
          }
          statements.push(statement)

          break
        case this.h5pVideoClass.PAUSED:
          if (currentTime === duration) {
            break //avoid to sent statement when video has ended
          }
          statement.result.extensions[
            'http://id.tincanapi.com/extension/ending-point'
          ] = this.secondsAsISO8601Duration(currentTime)

          if (this.lastState === this.h5pVideoClass.PLAYING) {
            const watchedStatement = LrsClient.cloneStatement(statement)
            watchedStatement.result.extensions[
              'http://id.tincanapi.com/extension/starting-point'
            ] = this.secondsAsISO8601Duration(this.lastCurrentTime)
            watchedStatement.verb.id = 'http://activitystrea.ms/schema/1.0/watch'
            watchedStatement.verb.display = { 'pt-BR': 'watched' }
            statements.push(watchedStatement)
          }

          statement.verb.id = 'http://id.tincanapi.com/verb/paused'
          statement.verb.display = { 'pt-BR': 'paused' }
          statements.push(statement)
          break
        case this.h5pVideoClass.ENDED:
          statement.result.completion = true
          statement.verb.id = 'http://activitystrea.ms/schema/1.0/complete'
          statement.verb.display = { 'pt-BR': 'completed' }
          statements.push(statement)

          break
        case this.h5pVideoClass.BUFFERING:
          //bug native xAPI Video State currentTime
          const endingPoint = currentTime
          let startingPoint = this.lastCurrentTime
          if (
            this.lastCurrentTimeForBuffering &&
            this.lastCurrentTimeForBuffering < startingPoint
          ) {
            startingPoint = this.lastCurrentTimeForBuffering
          }

          //avoid xAPI wrong time values
          if (startingPoint === endingPoint) {
            break
          }

          statement.result.extensions[
            'http://id.tincanapi.com/extension/starting-point'
          ] = this.secondsAsISO8601Duration(startingPoint)
          statement.result.extensions[
            'http://id.tincanapi.com/extension/ending-point'
          ] = this.secondsAsISO8601Duration(endingPoint)

          if (this.lastCurrentTime > currentTime) {
            statement.verb.id = 'http://activitystrea.ms/schema/1.0/return'
            statement.verb.display = { 'pt-BR': 'returned' }
            statements.push(statement)
          } else {
            statement.verb.id = 'http://id.tincanapi.com/verb/skipped'
            statement.verb.display = { 'pt-BR': 'skipped' }
            statements.push(statement)
          }
          break
        default:
        // do nothing
      }

      this.lastState = state
      this.lastCurrentTime = currentTime

      return statements
    }

    secondsAsISO8601Duration = seconds => {
      return `PT${Number.parseFloat(seconds).toFixed(2)}S`
    }

    cloneStatement = statement => {
      return JSON.parse(JSON.stringify(statement))
    }
  },
  Statement: class {
    constructor(options) {
      this.statement = options.statement
      this.actorId = options.actorId
      this.platform = options.platform

      if (!this.statement) {
        throw new Error(
          'statement missing!!. You can try something like: new Statement({ statement: {actor: {name: "ola"}} })',
        )
      }
    }

    toLrs = () => {
      this.formatVerb()
      this.formatObject()
      this.formatContext()
      this.formatTimestamp()

      console.log('FINAL STATEMNETE')
      console.log(this.statement)

      return this.statement
    }

    formatVerb = () => {
      if (!this.statement.verb) {
        throw new Error('Missing verb')
      }

      if (!this.statement.verb.id) {
        throw new Error('Missing verb id')
      }

      this.statement.verb.display = this.localeAsBr(this.statement.verb.display)
    }

    formatObject = () => {
      if (!this.statement.object) {
        throw new Error('Missing object')
      }

      if (!this.statement.object.id) {
        throw new Error('Missing object id')
      }

      if (!this.statement.object.definition) {
        throw new Error('Missing object definition')
      }

      if (!this.statement.object.definition.type) {
        throw new Error('Missing object definition type')
      }

      if (!this.statement.object.definition.name && !this.statement.object.definition.description) {
        throw new Error('Missing object definition name')
      }

      this.statement.object.objectType = 'Activity'
      this.statement.object.definition.name = this.objectDefinitionName()

      if (this.statement.object.definition.description) {
        delete this.statement.object.definition.description
      }
    }
    formatContext = () => {
      if (!this.statement.context) {
        this.statement.context = {}
      }

      this.statement.context.platform = this.platform
    }

    formatTimestamp = () => {
      if (!this.statement.timestamp) {
        const now = new Date()
        this.statement.timestamp = now.toISOString()
      }
    }

    objectDefinitionName = () => {
      const name =
        this.statement.object.definition.name || this.statement.object.definition.description
      return this.localeAsBr(name)
    }

    localeAsBr = locale => {
      return {
        'pt-BR': Object.values(locale)[0],
      }
    }
  },
}

export default LrsClient
